/**
 * 认证模块接口
 * @description 登录、验证码、用户机构等认证相关接口
 */

import axios from "@/utils/request";
import Api from "../api";
import * as Request from "../request.type";
import * as ResponseData from "../response.type";

/**
 * 登录
 * @param data 登录数据
 * @returns 登录结果
 */
export const Http_Login = async (params: Request.LoginParams) => {
  return await axios.post<ResponseData.LoginData>(Api.GET_LOGIN, params);
};

/**
 * 获取验证码
 * @param data 验证码数据
 * @returns 验证码结果
 */
export const Http_getVerifyCode = async () => {
  return await axios.get<ResponseData.VerifyCodeData>(Api.GET_VERIFY_CODE);
};

/**
 * 获取用户机构
 * @param 用户账号
 * @returns 用户机构结果
 */
export const Http_getUserStore = async (
  /** 账号 */
  account: string
) => {
  return await axios.get<ResponseData.UserStoreItemData[]>(Api.GET_USER_STORE, {
    params: {
      account,
    },
  });
};

/**
 * 获取用户资产信息
 * @returns 用户资产信息
 */
export const Http_getUserAsset = async () => {
  return await axios.get<ResponseData.UserAssetData>(Api.GET_USER_ASSET);
};
